module.exports = __webpack_public_path__ + "img/label2.366cbffd.png";